import request from '#/utils/request';
import { parseVer4DetailResponse } from '#/api/adapters/envelope';

/**
 * 建議維修報告單號。
 * GET `/aftersales/repair-report/next-no`
 * 成功 `data`＝字串建議單號（可編輯後放 create 的 `repairReportNo`）。
 */
export async function fetchRepairReportNextNo() {
  const { data: raw } = await request.get('/aftersales/repair-report/next-no');
  return parseVer4DetailResponse(raw);
}
